import { Injectable, effect, inject, signal } from '@angular/core';
import { LessonsProjectService } from './lessons-project.service';

@Injectable({
  providedIn: 'root',
})
export class EventBusService {
  private clearLessonsStorageSignal = signal(false);
  private lessonsService = inject(LessonsProjectService);

  constructor() {
    effect(() => {
      if (this.clearLessonsStorageSignal()) {
        this.clearStorage();
        this.clearLessonsStorageSignal.set(false);
      }
    });
  }
  emitClearLessonsStorage(): void {
    this.clearLessonsStorageSignal.set(true);
  }

  private clearStorage(): void {
    sessionStorage.removeItem('selectedSet');
    sessionStorage.removeItem('stflow');
    sessionStorage.removeItem('formflow');
    sessionStorage.removeItem('lessonFlow');
    sessionStorage.removeItem('finishLesson');
    sessionStorage.removeItem('project');
    sessionStorage.removeItem('finishedLesson');
    sessionStorage.removeItem('fatherProject');
    this.lessonsService.clearAnswers();
    this.lessonsService.finnishedLessonReset();
    this.lessonsService.clearDraft();
  }

  scrollToTop(): void {
    const container = document.querySelector('.main-content');
    container?.scrollTo(0, 0);
  }
}
